// This file was auto-generated by Fern from our API Definition.
export const ErrorPolicy = {
    Exception: "exception",
    Placeholder: "placeholder",
    Keep: "keep",
};
